import { client } from 'data/client';
import { Input } from 'model/campaign';
import { Token } from '../context/AuthContext/token';

export type GetMailMergesDto = Partial<{
  limit: number;
  offset: number;
  'lastTimeUsed[gte]': string;
  'lastTimeUsed[lte]': string;
  fields: keyof GetMailMergesDto;
  excludeTracking: boolean;
}>;

type GetCampaignsResponse = {
  items: Input[];
};

function denormalizeParams(params: GetMailMergesDto) {
  const denormalizedParams = { ...params };
  if (params['lastTimeUsed[gte]']) {
    denormalizedParams['lastTimeUsed[gte]'] = new Date(
      params['lastTimeUsed[gte]'],
    ).toISOString();
  }
  if (params['lastTimeUsed[lte]']) {
    denormalizedParams['lastTimeUsed[lte]'] = new Date(
      params['lastTimeUsed[lte]'],
    ).toISOString();
  }
  return denormalizedParams;
}

export async function getMailMerges(
  key: string,
  userId: string,
  params: GetMailMergesDto,
) {
  const denormalizedParams = denormalizeParams(params);
  const { idToken } = Token.get();
  const { data } = await client.get<GetCampaignsResponse>(
    `/users/${userId}/campaigns`,
    {
      params: denormalizedParams,
      headers: {
        'X-ID-Token': `Bearer ${idToken}`,
      },
    },
  );
  return data.items;
}
